<template>
  <b-sidebar
    id="qc-reject-import-sidebar"
    :visible="isImportSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="onHidden"
    @change="value => $emit('update:is-import-sidebar-active', value)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Import QC Reject
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <div class="px-2 py-1">
        <b-alert
          show
          variant="light-warning"
        >
          Kolom Excel yang didukung: <strong>item_code</strong>, <strong>qty_reject</strong>, <strong>sale_price</strong>, <strong>reason</strong>, <strong>note</strong>, <strong>reported_at</strong>
        </b-alert>

        <b-button
          href="/templates/qc_reject_import_template.xlsx"
          download
          variant="outline-primary"
          block
          class="mb-2"
        >
          <feather-icon
            icon="DownloadIcon"
            size="16"
            class="mr-50"
          />
          Download Template Excel
        </b-button>

        <b-form-group label="File Excel">
          <b-form-file
            v-model="file"
            accept=".xls,.xlsx"
            :disabled="isLoading"
          />
        </b-form-group>

        <b-button
          variant="primary"
          :disabled="!file || isLoading"
          @click="submitImport"
        >
          <b-spinner
            v-if="isLoading"
            small
            class="mr-50"
          />
          Import Excel
        </b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BAlert,
  BButton,
  BFormFile,
  BFormGroup,
  BSidebar,
  BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import store from '@/store'

export default {
  components: {
    BAlert,
    BButton,
    BFormFile,
    BFormGroup,
    BSidebar,
    BSpinner,
  },
  model: {
    prop: 'isImportSidebarActive',
    event: 'update:is-import-sidebar-active',
  },
  props: {
    isImportSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const file = ref(null)
    const isLoading = ref(false)

    const resetState = () => {
      file.value = null
      isLoading.value = false
    }

    const onHidden = () => {
      emit('update:is-import-sidebar-active', false)
      resetState()
    }

    const submitImport = () => {
      if (!file.value) {
        return
      }

      isLoading.value = true

      store.dispatch('app-qc-reject/importQcRejects', file.value)
        .then(() => {
          emit('refetch-data')
          emit('update:is-import-sidebar-active', false)
          resetState()
        })
        .finally(() => {
          isLoading.value = false
        })
    }

    return {
      file,
      isLoading,
      onHidden,
      submitImport,
    }
  },
}
</script>
